import "./CoveringsAndCoatings.module.css";
import Header from "@/reusable_sections/Header";
import RoofingHero from "./sections/RoofingHero";
import Coatings from "./sections/Coatings";
import Revestimentos from "./sections/Revestimentos";
import Benefits from "./sections/Benefits";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function CoveringsAndCoatingsPage() {
  return <div>
      <Header />
      
      <RoofingHero />
      <Coatings />
      <Revestimentos />
      <Benefits />
      <CallToAction />
      <Footer />
    </div>;
}